<template>
  <div v-if="examRoom && $route.query.battleType != 2" class="faceTipBox">
    <div v-show="false">
      <img :src="$t('proctoringQRcode')" alt="" srcset="">
      <img :src="$t('QRCodeHover')" alt="" srcset="">
      <img :src="$t('QRCodeActive')" alt="" srcset="">
    </div>
    <div v-if="beginRadio.content == 1 && $route.query.examId === beginRadio.examId" class="radioBox">
      <div class="radioTitle" :class="$i18n.locale === 'en'? '' : 'enRadioTitle'">{{$t('beginRadio')}}</div>
    </div>
    <div class="cursor helpBox" @click="changeHelp(true)" v-show="helpFace">
      <img class="helpBoxTip" v-show="unRead" src="https://img.webloom.cn/img/newMessage.png" alt="" srcset="">
      <img class="helpBoxTitle" :src="$i18n.locale === 'en' ? 'https://img.webloom.cn/img/teacherE1.png' : 'https://img.webloom.cn/img/teacherC1.png'" alt="" srcset="">
    </div>
    <div class="sendMessage" style="cursor:default;" v-show="!helpFace">
      <div class="input">
        <img @click="closeTip" style="cursor:pointer" class="closeTip" src="https://img.webloom.cn/img/closeTip.png" alt="">
        <div class="line"></div>
        <div id="chatBox" class="tipBox" ref="tipBox">
          <template v-if="chatRecord.length > 0">
            <!-- 0学生 1监考员 -->
            <div class="tipBoxItem" :class="vo.fromAccountRole === 2 || vo.fromAccountRole === 8 || vo.fromAccountRole === 3 ? '' : 'tipBoxItem1'" v-for="(vo,i) in chatRecord" :key="i">
              <div class="'tipBoxItem1">{{vo.fromAccountRole === 2 || vo.fromAccountRole === 8 ? $t('Invigilator') : vo.fromAccountRole === 3 ? $t('Administrator') : userName}}  {{$utils.timestampToStr(vo.msgTime, 'Y.M.D h:m:s')}}</div>
              <div class="tipBoxItemBox" :class="vo.fromAccountRole === 2 || vo.fromAccountRole ===  8 || vo.fromAccountRole === 3 ? '' : 'tipBoxItemBox1'">
                <template v-if="!vo.isQRCode">
                  <template v-if="vo.fromAccountRole === 1">
                    <img class="sendDefault sendDefault1" @click="()=>{text = vo.msgContent, submit(i)}" v-if="vo.noSend === 1" src="../../../assets/img/test/tips.png" alt="">
                    <img v-if="vo.beSending" class="sendDefault" src="https://img.webloom.cn/img/loading.gif" alt="">
                  </template>
                  <div class="tipBoxItemDesc" v-if="vo.fromAccountRole !== 8 && vo.fromAccountRole !== 9 && vo.msgCommonId !== '26723157079798290' && vo.msgCommonId !== '26723157079798277'" :class="vo.fromAccountRole === 2 || vo.fromAccountRole === 3 || vo.fromAccountRole === 8 ? 'monitorMessage2' : 'tipBoxItem2'" v-html="isHttpUrl(vo.msgContent)"></div>
                  <div class="tipBoxItemDesc" v-else-if="vo.fromAccountRole !== 8 && vo.fromAccountRole !== 9 && (vo.msgCommonId === '26723157079798290' || vo.msgCommonId === '26723157079798277')" :class="vo.fromAccountRole === 2 || vo.fromAccountRole === 3 || vo.fromAccountRole === 8 ? 'monitorMessage2' : 'tipBoxItem2'">
                    <div class="answerBox">
                      <div class="answerText" v-html="isHttpUrl(vo.msgContent)"></div>
                      <img class="mobileImg" :src="language === 'zh' ? qrcodeZh:qrcodeEn" alt="" srcset="">
                    </div>
                  </div>
                  <div class="tipBoxItemDesc" style="white-space: unset;" v-else :class="[vo.fromAccountRole === 2 || vo.fromAccountRole ===  8 || vo.fromAccountRole === 3 ? 'monitorMessage2' : 'tipBoxItem2',vo.fromAccountRole === 9 ? '': 'tipBoxItemDesc1',vo.level === 3 ? 'tipBoxItemDesc2' : '']">
                    <div class="automaticResponse" v-if="vo.fromAccountRole === 9 && (vo.levelItem3 > -1 || vo.levelItem > -1)">{{ vo.levelItem3 > -1 ? levelList[vo.levelItem].levelTwo[vo.levelItem3][$t('automaticName')] : vo.levelItem > -1 ? levelList[vo.levelItem][$t('automaticName')] : '' }}</div>
                    <template v-else>
                      <template v-if="vo.level === 1 && levelList.length>0">
                        <div class="wantToConsult">{{ $t('wantToConsult') }}</div>
                        <div class="automaticResponseBox" :class="{automaticResponseBoxUnfold: unfold && !openOneSelf, openOneSelf: openOneSelf}">
                          <div @click="changeUnfold" v-show="showUnfold" class="unfoldBox">
                            <div>{{$t('faceTipUnfold')}}</div>
                            <img class="unfoldImg" src="https://img.webloom.cn/img/faceTipUnfold.png" alt="" srcset="">
                          </div>
                          <div class="automaticResponseItem" v-for="(voi,ii) in levelList" :key="ii">
                            <div class="ItemClose" @click="clickLevelOne(ii,voi)">
                              <div class="automaticResponse">{{ voi[$t('automaticName')] }}</div>
                              <img :class="{openQuestion:clickQuestion === ii}" src="https://img.webloom.cn/img/faceTipMore.png" alt="" srcset="">
                            </div>
                            <div class="itemQuestionBox" v-if="clickQuestion === ii" :class="{openQuestion:clickQuestion === ii}">
                              <div class="itemQuestion" v-for="(voi2,ii2) in levelList[clickQuestion].levelTwo" @click="clickLevelTwo(clickQuestion, ii2,voi2[$t('automaticName')],voi2)" :key="ii2">
                                <img class="itemBlock" src="https://img.webloom.cn/img/itemBlock.png" alt="" srcset="">{{ voi2[$t('automaticName')] }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <div class="answerBox" v-if="vo.level === 3">
                        <div class="answerText">{{ vo.answer[$t('automaticName')] }}</div>
                        <img class="mobileImg" v-if="vo.msgCommonId === '26723157079798290' || vo.msgCommonId === '26723157079798277'" :src="language === 'zh' ? qrcodeZh:qrcodeEn" alt="" srcset="">
                        <div class="isSolved" v-if="vo.clickSolved !== 'unSolved'">
                          <div class="Solved" :class="{yesSolved:vo.clickSolved === 'Solved'}" style="cursor:pointer" @click="()=>{if(vo.clickSolved === 'Solved') return;vo.clickSolved = 'Solved';addAutoRecord(vo.answer,1)}">
                            <img class="solvedImg" v-if="vo.clickSolved === 'Solved'" src="https://img.webloom.cn/img/faceTipSolved.png" alt="" srcset="">
                            <img class="solvedImg" v-else src="https://img.webloom.cn/img/faceTipIsSolved1.png" alt="" srcset="">
                          {{ $t('Solved') }}</div>
                          <div class="Solved unSolved" v-if="vo.clickSolved !== 'Solved'" style="cursor:pointer" @click="()=>{if(vo.clickSolved === 'unSolved') return;vo.clickSolved = 'unSolved';addAutoRecord(vo.answer,0)}">
                            <img class="solvedImg" src="https://img.webloom.cn/img/faceTipUnSolved.png" alt="" srcset="">{{ $t('Unsolved') }}</div>
                        </div>
                        <div class="clickSolved" v-if="vo.clickSolved === 'unSolved'">{{ $t('cannotBeResolved') }}</div>
                      </div>
                    </template>
                  </div>
                  <template v-if="vo.fromAccountRole === 2">
                    <img class="sendDefault sendDefault1" @click="()=>{text = vo.msgContent, submit(i)}" v-if="vo.noSend === 1" src="../../../assets/img/test/tips.png" alt="">
                    <img v-if="vo.beSending" class="sendDefault" src="https://img.webloom.cn/img/loading.gif" alt="">
                  </template>
                  <template v-if="vo.fromAccountRole === 8">
                    <img class="sendDefault sendDefault1" @click="()=>{text = vo.msgContent, submit(i)}" v-if="vo.noSend === 2" src="../../../assets/img/test/tips.png" alt="">
                    <img v-if="vo.beSending" class="sendDefault" src="https://img.webloom.cn/img/loading.gif" alt="">
                  </template>
                </template>
              </div>
            </div>
          </template>
          <div v-show="false" class="qrCodeUrl" ref="qrCodeUrl"></div>
        </div>
        <div class="inputBox" ref="inputBox"><div class="input">
            <el-input
            @keyup.enter.native="submit"
            onkeydown="if (event.keyCode===13){return false;}"
            style="word-break: break-word;"
            onpaste="return false" oncut="return false" oncopy="return false"
            type="textarea"
            placeholder=""
            :value="text"
            maxlength="1000"
            resize="none"
            :autosize="{ minRows: 1, maxRows: 4}"
            @input="replaceExpression"
            >
            </el-input>
            <div @click="submit" class="submit" :class="text.trim().length > 0 ? '' : 'noSubmit'">{{$t('faceTipBoxSend')}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import createQrCode from './createQrCode'
export default {
  data () {
    return {
      openFirstRecord: null,   // 让用户被动打开聊天框的信息
      openOneSelf: false,
      unfold: false,   // 是否展开
      showUnfold: true,  // 是否展示展开
      totalCount: 0,
      levelI: 0,
      levelIi: 0,
      levelList: [],
      text: '',
      inputBoxHeight: '',
      unRead: 0,           // 未读数量
      help: true,
      helpFace: true,
      roomId: '',
      userName: '',
      qrcodeZh: '',
      qrcodeEn: '',
      chatRecord: [],      // 聊天记录
      // faceTipList: [],      // 人脸识别结果
      examRoom: 0,       // 监考房间是否开启
      mobileVideo: 0,
      mobileVideoToken: '',
      needGetRecord: false,       // 是否发起了请求获取聊天记录
      pageObj: {currentPage: 1, pageSize: 10},
      clickQuestion: -1,
      canGetAutoAnswer: {},
      examConfigChange: false    // 考试配置被修改
    }
  },
  computed: mapState({
    nowDate: state => state.common.nowDate,  // 当前时间
    TIMChatRecord: state => state.test.TIMChatRecord,
    revocationMessage: state => state.test.revocationMessage,
    // faceTipDesc: state => state.test.faceTipDesc,
    examConfig: state => state.test.examConfig,
    beginRadio: state => state.test.beginRadio,
    language () {
      return this.$i18n.locale === 'en' ? 'en' : 'zh'
    }
  }),
  watch: {
    help (val) {
      if (!val) {
        this.getChatRecord(true, true)
        // 聊天框打开并且当前考试配置被修改过
        if (this.examConfigChange) {
          this.getUnRead()
          this.examConfigChange = false
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.inputBoxHeight = this.$refs.inputBox.scrollHeight
          this.$refs.tipBox.scrollTop = this.$refs.tipBox.scrollHeight
        }, 100)
      })
      this.clickQuestion = -1
    },
    beginRadio: {
      immediate: true,
      deep: true,
      handler: function (val) {
        if (val && val.audioEndTime) {
          let timer = setInterval(() => {
            if (this.nowDate >= val.audioEndTime) {
              clearInterval(timer)
              this.set_beginRadio({content: 0, examId: val.examId})
            }
          }, 1000)
        }
      }
    },
    $route: {
      deep: true,
      handler: function (val) {
        if (val.query.examId !== sessionStorage.getItem('bloom-pc-TimExamId')) {
          sessionStorage.setItem('bloom-pc-TimExamId', this.$route.query.examId)
          this.getUnRead()
        }
      }
    },
    text (val) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.tipBox.scrollTop = this.$refs.tipBox.scrollHeight
          this.inputBoxHeight = this.$refs.inputBox.scrollHeight
        }, 100)
      })
    },
    // 撤回
    revocationMessage: {
      immediate: true,
      deep: true,
      handler: function (val) {
        if (val && val.topicId !== this.$route.query.examId) return
        this.totalCount--
        for (let i = 0; i < this.chatRecord.length; i++) {
          const element = this.chatRecord[i]
          if (element.chatMsgId === val.chatMsgId) {
            this.chatRecord.splice(i, 1)
            break
          }
        }
      }
    },
    // 聊天消息
    TIMChatRecord (val) {
      if (val.topicId !== this.$route.query.examId) return
      let length = this.chatRecord.length
      let lastList = this.chatRecord.slice(length - 10, length)
      let list = lastList.filter(res => {
        return res.chatMsgId === val.chatMsgId
      })
      if (list.length === 0) {
        this.chatRecord.push({...val})
        this.totalCount++
        this.unRead = this.unRead + 1
        if (!this.help) {
          this.unRead = 0
          this.readChat({examId: this.$route.query.examId, chatMsgId: val.chatMsgId})
        } else {
          this.openFirstRecord = val
          this.changeHelp()
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.tipBox.scrollTop = this.$refs.tipBox.scrollHeight
            this.inputBoxHeight = this.$refs.inputBox.scrollHeight
          }, 100)
        })
      }
    },
    examConfig (val) {
      if (val.userId === this.userId) {
        this.examConfigChange = true
      }
    }
  },
  mounted () {
    this.userId = ''
    if (JSON.parse(this.$utils.cache('userData'))) {
      this.userId = JSON.parse(this.$utils.cache('userData')).userId
    }
    sessionStorage.setItem('bloom-pc-TimExamId', this.$route.query.examId)
    if (location.href.toUpperCase().indexOf('bloomEquipment'.toUpperCase()) < 0) this.getUnRead()
  },
  methods: {
    ...mapMutations(['set_beginRadio']),
    changeUnfold () {
      this.unfold = true
      setTimeout(() => {
        this.showUnfold = false
      }, 1200)
    },
    addAutoRecord (answer, isSolve) {
      if (this.canGetAutoAnswer && this.canGetAutoAnswer[answer.autoId] && this.canGetAutoAnswer[answer.autoId] === true) {
        return
      }
      this.$set(this.canGetAutoAnswer, answer.autoId, true)
      this.$api.postNoLoading('TEST_MONITOR_ADDAUTORECORD', {
        examId: this.$route.query.examId,
        autoId: answer.autoId,
        autoType: 3,
        isSolve
      }, res => {
        this.$set(this.canGetAutoAnswer, answer.autoId, false)
        console.log(res)
      })
    },
    clickLevelOne (i, content) {
      if (this.canGetAutoAnswer && this.canGetAutoAnswer[i] && this.canGetAutoAnswer[i] === true) {
        return
      }
      // 重复点击时，关闭下拉框，不需要请求二级问题
      if (i === this.clickQuestion) {
        this.clickQuestion = -1
        return
      }
      this.$set(this.canGetAutoAnswer, i, true)
      this.$api.postNoLoading('TEST_MONITOR_GETAUTOANSWER', {
        examId: this.$route.query.examId,
        autoId: content.autoId,
        autoType: 2
      }, res => {
        this.$set(this.canGetAutoAnswer, i, false)
        this.$set(this.levelList, i, {...this.levelList[i], levelTwo: res.data})
        this.clickQuestion = i
      })
    },
    initHeight () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.inputBoxHeight = this.$refs.inputBox.scrollHeight
          this.$refs.tipBox.scrollTop = this.$refs.tipBox.scrollHeight
        }, 100)
      })
    },
    clickLevelTwo (i, ii, content, vo) {
      if (this.canGetAutoAnswer && this.canGetAutoAnswer[i + 'two' + ii] && this.canGetAutoAnswer[i + 'two' + ii] === true) {
        return
      }
      this.$set(this.canGetAutoAnswer, i + 'two' + ii, true)
      this.chatRecord.push({chatMsgId: Date.now(), fromAccountRole: 9, msgTime: Date.now(), levelItem: i, levelItem3: ii, msgContent: content, userName: this.userName ? this.userName : this.userId})
      this.initHeight()
      this.$api.postNoLoading('TEST_MONITOR_GETAUTOANSWER', {
        examId: this.$route.query.examId,
        autoId: vo.autoId,
        autoType: 3
      }, res => {
        let obj = res.data.length > 0 ? res.data[0] : {}
        this.$set(this.canGetAutoAnswer, i + 'two' + ii, false)
        setTimeout(() => {
          this.chatRecord.push({msgCommonId: obj.autoId, level: 3, answer: obj, clickSolved: 'isSolved', levelItem: i, levelItem3: ii, fromAccountRole: 8, time: Date.now(), userName: '监考员'})
          this.initHeight()
        }, 500)
      })
    },
    QRCodeBgChange (item) {
      this.$nextTick(() => {
        let div = this.$refs.QRCode
        let str = `url(${this.$t('proctoringQRcode')})`
        if (item === 1) {
          str = `url(${this.$t('QRCodeHover')})`
        }
        if (item === 3) {
          str = `url(${this.$t('QRCodeActive')})`
        }
        if (item === 4) {
          str = `url(${this.$t('QRCodeHover')})`
        }
        div.style.backgroundImage = str
      })
    },
    getQRCode () {
      // if (!this.mobileVideo) return
      setTimeout(() => {
        try {
          this.$nextTick(() => {
            setTimeout(() => {
              let width = window.screenWidth / 1920 * 140
              if (!(width && width > 0)) width = 140
              if (!this.$refs.qrCodeUrl) return
              this.$refs.qrCodeUrl.innerHTML = ''
              let qrcodeEn = createQrCode(this.$refs.qrCodeUrl, this.$route.query.examId, this.mobileVideoToken, 'en', 2, width, width, '#000000', '#ffffff', this.$route.query.timeType)
              let qrcodeZh = createQrCode(this.$refs.qrCodeUrl, this.$route.query.examId, this.mobileVideoToken, 'zh', 2, width, width, '#000000', '#ffffff', this.$route.query.timeType)
              setTimeout(() => {
                this.qrcodeEn = qrcodeEn._oDrawing._elImage.attributes.src.value
                this.qrcodeZh = qrcodeZh._oDrawing._elImage.attributes.src.value
              }, 100)
            }, 100)
          })
        } catch (err) {
          console.log(err)
        }
      }, 100)
    },
    isHttpUrl (url) {
      var reg = new RegExp('(http[s]{0,1}|ftp)://[a-zA-Z0-9\\.\\-]+\\.([a-zA-Z]{2,4})(:\\d+)?(/[a-zA-Z0-9\\.\\-~!@#$%^&*+?:_/=<>]*)?', 'gi')
      let text = url.replace(reg, function (httpText) {
        return '<a href="' + httpText + '" target="_blank">' + httpText + '</a>'
      })
      return text
    },
    changeHelp (bol = false) {
      // bol = true   为用户主动点击打开私信
      this.help = false
      this.pageObj = {currentPage: 1, pageSize: 10}
      this.chatRecord = []
      if (bol) {
        this.showUnfold = false
        this.unfold = true
        this.openOneSelf = true
      } else {
        this.showUnfold = true
        this.unfold = false
        this.openOneSelf = false
      }
    },
    // 获取用户是否存在未读消息
    getUnRead () {
      try {
        this.$api.postNoLoading('TEST_GETHELP', {examId: this.$route.query.examId, isMonitorData: 1}, res => {
          this.examRoom = res.data.examRoom
          this.levelList = res.data.autoAnswerInfo
          if (this.examRoom === 0) return
          this.roomId = res.data.roomId
          this.unRead = res.data.unRead
          this.userName = res.data.userName
          this.mobileVideo = res.data.mobileVideoToken
          this.mobileVideoToken = res.data.mobileVideoToken ? res.data.mobileVideoToken : ''
          this.getQRCode()
          if (this.unRead > 0) this.changeHelp()
        })
      } catch (err) {
        console.log(err)
      }
    },
    // 聊天记录已读
    readChat (data) {
      this.$api.postNoLoading('TEST_INV_READCHAT', {...data}, res => {})
    },
    // 获取初始聊天记录
    getChatRecord (bool = true, bol = false) {
      try {
        let scrollTop = 0
        if (document.getElementById('chatBox')) {
          scrollTop = document.getElementById('chatBox').scrollHeight
        }
        let data = {
          startIndex: this.pageObj.pageSize * (this.pageObj.currentPage - 1),
          pageSize: this.pageObj.pageSize,
          topicId: this.$route.query.examId,
          roomId: this.roomId
        }
        // this.$api.postNoLoading('TEST_INV_GETCHATINFO', {...data}, res => {
        this.$api.postNoLoading('NEW_CONTENT_CHAT_GETDETAIL', {...data}, res => {
          this.helpFace = false
          let list = res.data.list
          // this.chatRecord = list.concat(this.chatRecord).sort((a, b) => { return a.msgTime - b.msgTime })
          // this.chatRecord = [...new Set(this.chatRecord)]
          // 1. 去重（基于 id）
          const uniqueData = [...new Map(list.concat(this.chatRecord).map(item => [item.chatMsgId, item])).values()]

          // 2. 按时间升序排序（从小到大）
          this.chatRecord = uniqueData.sort((a, b) => new Date(a.msgTime) - new Date(b.msgTime))

          this.totalCount = res.data.totalCount
          // 当前请求到的数据小于10 ，且总条数大于当前数据
          if (this.chatRecord.length < 10 && this.chatRecord.length < this.totalCount) {
            this.pageObj.currentPage++
            this.getChatRecord()
          }
          if (bol && this.levelList.length > 0) {
            // 用户主动打开
            if (this.openOneSelf) this.chatRecord.push({level: 1, fromAccountRole: 8, time: Date.now()})
            // 有新消息打开
            else {
              console.log(this.openOneSelf, this.openFirstRecord, this.chatRecord)
              let index = 0
              for (let i = this.chatRecord.length - 1; i > -1; i--) {
                const element = this.chatRecord[i]
                if (element.chatMsgId === this.openFirstRecord.chatMsgId) {
                  index = this.chatRecord.length - i
                }
              }
              console.log(index)
              this.chatRecord.splice(this.chatRecord.length - index, 0, {level: 1, fromAccountRole: 8, time: Date.now()})
            }
          }
          this.unRead = 0
          this.needGetRecord = true
          this.$nextTick(() => {
            if (bool) {
              this.inputBoxHeight = this.$refs.inputBox.scrollHeight
              this.$refs.tipBox.scrollTop = this.$refs.tipBox.scrollHeight
            } else {
              this.$refs.tipBox.scrollTop = document.getElementById('chatBox').scrollHeight - scrollTop
            }
            this.$nextTick(() => {
              document.getElementById('chatBox').addEventListener('scroll', this.scrollFun, true)
            })
          })
        })
      } catch (err) {
        this.helpFace = false
        console.log(err)
      }
    },
    scrollFun () {
      let div = document.getElementById('chatBox')
      let scrollTop = div.scrollTop
      if (scrollTop < 20 && this.totalCount > this.chatRecord.length) {
        if (!this.needGetRecord) return
        this.needGetRecord = false
        this.pageObj.currentPage = this.pageObj.currentPage + 1
        this.getChatRecord(false)
      }
    },
    replaceExpression (e) {
      this.inputBoxHeight = this.$refs.inputBox.scrollHeight
      this.$refs.tipBox.scrollTop = this.$refs.tipBox.scrollHeight
      let reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g // 表情符号正则
      this.text = e.replace(reg, '')
    },
    closeTip () {
      this.help = true
      this.helpFace = true
      this.count = 1
      document.getElementById('chatBox').removeEventListener('scroll', this.scrollFun, true)
    },
    submit (ind) {
      if (this.text.trim().length === 0) return
      this.$refs.tipBox.scrollTop = this.$refs.tipBox.scrollHeight
      this.inputBoxHeight = this.$refs.inputBox.scrollHeight
      let text = this.text
      this.text = ''
      let time = Date.now()
      if (ind > -1) {
        this.chatRecord.splice(ind, 1)
      }
      let itemIndex = this.chatRecord.length
      this.$set(this.chatRecord, itemIndex, {chatMsgId: this.nowDate, fromAccountRole: 1, userName: this.userName ? this.userName : this.userId, msgContent: text, msgTime: time, beSending: 1})
      // let data = {
      //   examId: this.$route.query.examId,
      //   roomId: this.roomId,
      //   content: text,
      //   userName: this.userName,
      //   chatContentType: 0      // 用户消息
      // }
      let data = {
        msgContent: text,
        chatMsgType: 1,
        roomId: this.roomId,
        topicId: this.$route.query.examId
      }
      // 保存聊天记录
      // this.$api.postNoLoading('TEST_INV_SAVECHATCONTENT', {...data}, res => {
      this.$api.postNoLoading('NEW_CONTENT_CHAT_SENDMSG', {...data}, res => {
        this.$set(this.chatRecord, itemIndex, {fromAccountRole: 1, userName: this.userName ? this.userName : this.userId, msgContent: text, msgTime: time})
      }, err => {
        console.log(err)
        this.$set(this.chatRecord, itemIndex, {fromAccountRole: 1, userName: this.userName ? this.userName : this.userId, msgContent: text, msgTime: time, noSend: 1})
      }, err => {
        console.log(err)
        this.$set(this.chatRecord, itemIndex, {fromAccountRole: 1, userName: this.userName ? this.userName : this.userId, msgContent: text, msgTime: time, noSend: 1})
      })
    }
  }
}
</script>
<style lang="scss" scoped>
$width: 100vw/1920;
.faceTipBox{
  .radioBox{
    position: absolute;
    right: -10*$width;
    top: -155*$width;
    background-image: url('../../../assets/img/er.png');
    background-repeat: no-repeat;
    background-size:contain;
    height: 150*$width;
    width: 260*$width;
    box-sizing: border-box;
    .radioTitle{
      padding: 20*$width 30*$width;
      font-size: 14*$width;
      line-height: 16*$width;
    }
    .enRadioTitle{
      padding-top: 40*$width;
    }
  }
  .helpBox{
    font-size: 18*$width;
    padding-bottom: 40*$width;
    position: relative;
    width: 115*$width;
    height: 115*$width;
    .helpBoxTip{
      position: absolute;
      top: 0;
      right: 0;
      width: 32*$width;
      height: 27*$width;
    }
    .helpBoxTitle{
      width: 115*$width;
      height: 115*$width;
    }
  }
  .sendMessage{
    position: relative;
    width: 360*$width;
    height: 520*$width;
    background: #FFFFFF;
    border: 0.1*$width solid #D3E1FF;
    box-shadow: 0px 4*$width 18*$width 0px rgba(234,236,245,0.5);
    border-radius: 8*$width;
    .input{
      width: 100%;
      .closeTip{
        padding: 10*$width;
        position: absolute;
        top: 5*$width;
        right: 10*$width;
        cursor: pointer;
        height: 10*$width;
      }
      .line{
        margin-top: 40*$width;
        width: 100%;
        height: 1*$width;
        background: #EDF1F7;
      }
      .inputBox{
        position: absolute;
        bottom: 10*$width;
        padding: 20*$width;
        padding-bottom: 10*$width;
        .qrCode{
          height: 30*$width;
          margin-bottom: 2*$width;
          background-repeat: no-repeat;
          background-size: auto 100%;
          color:#7B7F87;
          .qrCodeImg{
            height: 30*$width;
          }
          &:hover{
          }
          &:active{
          }
        }
        .input{
          display: flex;
          align-items: flex-end;
          /deep/ .el-textarea{
            width: 250*$width !important;
          }
        }
        .submit{
          height: fit-content;
          margin-left: 10*$width;
          width: 48*$width;
          padding: 4*$width;
          text-align: center;
          background: #296BFF;
          cursor: pointer;
          border-radius: 4*$width;
          color: white;
        }
        .noSubmit{
          height: fit-content;
          margin-left: 10*$width;
          width: 48*$width;
          padding: 4*$width;
          text-align: center;
          background: rgba(41, 107, 255,.4);
          cursor: pointer;
          border-radius: 4*$width;
          color: white;
          cursor: default;
        }
      }
      .tipBox{
        height: 374*$width;
        margin: 12*$width 0;
        overflow: hidden;
        overflow-y: scroll;
        padding: 12*$width 24*$width;
        .tipBoxItem{
          padding-top: 24*$width;
          font-size: 12*$width;
          line-height: 16*$width;
          .tipBoxItem1{
            color: #C2C2C2;
            padding-bottom: 8*$width;
          }
          .tipBoxItemBox{
            display: flex;
            display: -webkit-box;
            align-items: center;
            .tipBoxItemDesc{
              max-width: 280*$width;
              box-sizing: border-box;
              font-family: PingFangSC-Regular, PingFang SC;
              margin-top: 8*$width;
              background: #F4F6FA;
              width: fit-content;
              word-break: break-word;
              white-space:pre-wrap;
              color: #000000;
              border-radius: 2*$width 8*$width 8*$width 8*$width;
              padding: 8*$width;
              .automaticResponse{
                word-break: break-word;
                white-space:pre-wrap;
              }
              .automaticResponseBox{
                padding: 0*$width 8*$width 8*$width;
                max-height: 87*$width;
                box-sizing: border-box;
                overflow: hidden;
                position: relative;
                .unfoldBox{
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: absolute;
                  width: 293*$width;
                  height: 29*$width;
                  bottom: 0;
                  left: 0;
                  background: linear-gradient( 180deg, rgba(250,251,253,0.6) 0%, #F4F6FA 100%);
                  border-radius: 2*$width 8*$width 8*$width 8*$width;
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 11*$width;
                  color: #296BFF;
                  line-height: 14*$width;
                  cursor: pointer;
                  .unfoldImg{
                    margin-left: 2*$width;
                    width: 8*$width;
                    height: 8*$width;
                  }
                }
                .automaticResponse{
                  word-break: break-word;
                  white-space:pre-wrap;
                }
                .automaticResponseItem{
                  cursor: pointer;
                  font-weight: 400;
                  color: #212121;
                  line-height: 16*$width;
                  border-bottom: 1*$width solid #e6e7eb;
                  .ItemClose{
                    padding: 6*$width 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .openQuestion{
                      transform: rotate(90deg);
                    }
                    img{
                      width: 12*$width;
                      height: 12*$width;
                    }
                  }
                  .itemQuestionBox{
                    cursor: default;
                    padding-bottom: 6*$width;
                    .itemQuestion{
                      cursor: pointer;
                      width: fit-content;
                      padding-top: 6*$width;
                      display: flex;
                      justify-content: start;
                      align-items: start;
                      font-size: 12*$width;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #296BFF;
                      line-height: 16*$width;
                      text-decoration: underline;
                      text-decoration-color: #296BFF;
                      .itemBlock{
                        margin-right: 6*$width;
                        margin-top: 6*$width;
                        width: 6*$width;
                        height: 6*$width;
                        background: #296BFF;
                        border-radius: 100%;
                      }
                    }
                    
                  }
                }
              }
              @keyframes automaticAni {
                0%{
                  max-height: 87*$width;
                }
                100%{
                  max-height: 1000*$width;
                }
              }
              .automaticResponseBoxUnfold{
                animation: automaticAni 10s forwards;
              }
              .openOneSelf{
                max-height: 1000*$width;
              }
              .wantToConsult{
                padding: 0 8*$width 8*$width;
                font-size: 12*$width;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #212121;
                line-height: 16*$width;
                border-bottom: 1*$width solid #e6e7eb;
              }
              .answerBox{
                font-weight: 400;
                color: #000000;
                line-height: 16*$width;
                font-size: 12*$width;
                .answerText{
                  padding: 0 8*$width;
                  padding-bottom: 9*$width;
                  word-break: break-word;
                  white-space:pre-wrap;
                }
                .mobileImg{
                  padding: 0 8*$width;
                  margin-bottom: 9*$width;
                }
                .isSolved{
                  border-top: 1*$width solid #e6e7eb;
                  display: flex;
                  
                  .Solved{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-weight: 400;
                    line-height: 16*$width;
                    font-size: 11*$width;
                    width: 50%;
                    box-sizing: border-box;
                    border-right: 1*$width solid #e6e7eb;
                    height: 24*$width;
                    .solvedImg{
                      width: 16*$width;
                      margin-right: 4*$width;
                    }
                  }
                  .yesSolved{
                    color: #296BFF;
                    width: 100%;
                    border-right:none;
                  }
                  .unSolved{
                    border-right:none;
                  }
                }
                
                .clickSolved{
                  border-top: 1*$width solid #e6e7eb;
                  font-size: 11*$width;
                  font-weight: 400;
                  color: #5D6066;
                  line-height: 16*$width;
                  padding: 4*$width;
                  text-align: center;
                }
              }
            }
            .tipBoxItemDesc1{
              padding: 8*$width 0;
              max-width: 280*$width;
            }
            .tipBoxItemDesc1{
              padding: 0;
              padding-top: 8*$width;
            }
            .sendDefault{
              margin-right: 10*$width;
              width: 20*$width;
              height: 21*$width;
            }
            .sendDefault1{
              cursor: pointer;
            }
            .tipBoxItem2{
              background: #D1E3FF;
              text-align: left;
              border-radius: 8*$width 2*$width 8*$width 8*$width;
            }
          }
          .tipBoxItemBox1{
            justify-content: end;
          }
          .showQRCodeBox{
            background: #F4F6FA;
            width: fit-content;
            word-break: break-word;
            white-space:pre-wrap;
            color: #000000;
            border-radius: 2*$width 8*$width 8*$width 8*$width;
            padding: 12*$width;
            img{
              margin-top: 8*$width;
            }
          }
        }
        .tipBoxItem1{
          text-align: right;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bloom-proctor/public/faceTipBox.vue